import { actions } from "./Actions";

const initialState = {
  isOutfitVisble: false,
  screenshot: null,
};

export function outfit(state = initialState, action) {
  switch (action.type) {
    case actions.SHOW_OUTFIT: {
      return {
        ...state,
        isOutfitVisble: action.isVisible,
        screenshot: action.screenshot,
      };
    }
    default:
      return state;
  }
}

export default outfit;
